import { useState, useEffect } from 'react';

const STORAGE_KEY = 'dismaman_conversations';

export const useLocalHistory = () => {
  const [localConversations, setLocalConversations] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        setLocalConversations(JSON.parse(saved));
      } catch (error) {
        console.error('Error parsing local conversations:', error);
      }
    }
  }, []);

  const saveConversation = (conversation) => {
    const updated = [conversation, ...localConversations.slice(0, 49)]; // Keep last 50
    setLocalConversations(updated);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  };

  const clearHistory = () => {
    setLocalConversations([]);
    localStorage.removeItem(STORAGE_KEY);
  };

  return {
    localConversations,
    saveConversation,
    clearHistory,
  };
};